import { watch, onMounted } from 'vue'

import { useContentful } from '@/components/common/contentful/composables/useContentful'
import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

import { useSettings } from '@/composables/useSettings'
import { useAppStore } from '@/stores/app'

export function useContentfulAutowireGlobal({
  componentName = '',
  parentComponentName = '',
  isContentfulAutowireOn = true,
  customInitData = null,
}) {
  const contentful = useContentful()
  const { contentfulState, initData: initDataOriginal } = useContentfulComponent()
  const settings = useSettings()
  const appStore = useAppStore()

  const initData = typeof customInitData === 'function' ? customInitData : initDataOriginal

  function getContentfulData() {
    contentfulState.value.loading = false
    const componentSettings = parentComponentName
      ? settings.contentfulMap[`${parentComponentName}-${componentName}`]
      : settings.contentfulMap[componentName]

    if (!componentSettings || !componentSettings.configurationSlot) {
      console.error('Contentful Error: missing field in component mapping')
      contentfulState.value.error = true
      return
    }

    const entry = contentful.service.getDataForComponent(componentSettings.configurationSlot)
    if (entry) {
      const payload = entry.fields ? entry.fields : entry
      initData(payload)
    }
  }

  watch(
    () => appStore.isInitialized,
    (isInitialized) => {
      if (isInitialized && isContentfulAutowireOn) getContentfulData()
    },
  )

  onMounted(() => {
    if (appStore.isInitialized && isContentfulAutowireOn) getContentfulData()
  })
}
